class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);

    // Save scroll position before fixing body
    this.scrollPosition = window.pageYOffset || document.documentElement.scrollTop;

    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    // Apply body scroll prevention with position adjustment for mobile
    document.body.classList.add('overflow-hidden');
    if (window.innerWidth <= 749) {
      document.body.style.top = `-${this.scrollPosition}px`;

      // Additional iOS Chrome fix: prevent elastic scroll
      const cartDrawerItems = this.querySelector('cart-drawer-items');
      if (cartDrawerItems) {
        cartDrawerItems.addEventListener('touchstart', this.handleTouchStart.bind(this), { passive: false });
        cartDrawerItems.addEventListener('touchmove', this.handleTouchMove.bind(this), { passive: false });
      }
    }
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);

    // Remove body scroll prevention and restore position
    document.body.classList.remove('overflow-hidden');
    if (window.innerWidth <= 749 && this.scrollPosition !== undefined) {
      document.body.style.top = '';
      window.scrollTo(0, this.scrollPosition);
      this.scrollPosition = undefined;

      // Clean up iOS Chrome touch event listeners
      const cartDrawerItems = this.querySelector('cart-drawer-items');
      if (cartDrawerItems) {
        cartDrawerItems.removeEventListener('touchstart', this.handleTouchStart.bind(this));
        cartDrawerItems.removeEventListener('touchmove', this.handleTouchMove.bind(this));
      }
    }
  }

  // Handle touch events for iOS Chrome scroll behavior
  handleTouchStart(e) {
    this.touchStartY = e.touches[0].clientY;
  }

  handleTouchMove(e) {
    const cartDrawerItems = e.currentTarget;
    const scrollTop = cartDrawerItems.scrollTop;
    const scrollHeight = cartDrawerItems.scrollHeight;
    const height = cartDrawerItems.clientHeight;
    const touchY = e.touches[0].clientY;
    const deltaY = this.touchStartY - touchY;

    // Prevent elastic bounce when scrolling past boundaries
    if ((scrollTop <= 0 && deltaY < 0) || (scrollTop >= scrollHeight - height && deltaY > 0)) {
      e.preventDefault();
    }
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
